import { render, staticRenderFns } from "./waschepacket.vue?vue&type=template&id=52a2195e&"
import script from "./waschepacket.vue?vue&type=script&lang=js&"
export * from "./waschepacket.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('52a2195e')) {
      api.createRecord('52a2195e', component.options)
    } else {
      api.reload('52a2195e', component.options)
    }
    module.hot.accept("./waschepacket.vue?vue&type=template&id=52a2195e&", function () {
      api.rerender('52a2195e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-259WRgZTUzYWy/JS/comp/waschepacket.vue"
export default component.exports